import { Button } from '@components/common/Button';
import { FormattedMessage } from 'react-intl';
import { Card } from '@pages/ApplicationFormPage/Cards/Card/Card';
import { useSearchParams } from 'react-router-dom';
import { useNavigateBack } from '@hooks/useNavigateBack';
import { ApplicationFormPageEnum } from '../types';
import { cardsQuestions } from './questions';
import { FC } from 'react';
import { ICardsProps } from './types';

export const Cards: FC<ICardsProps> = ({ cards, onAddCardRedirect, onEditCardRedirect, onRemoveCardById }) => {
  const navigateBack = useNavigateBack();
  const [searchParams, setSearchParams] = useSearchParams();

  const nextStepRedirectHandler = () => {
    searchParams.set('section', ApplicationFormPageEnum.STUDENT_LOANS);
    setSearchParams(searchParams);
  };

  const hasCards = cards.length > 0;

  return (
    <>
      <div className={'mb-8 flex items-baseline justify-between'}>
        <FormattedMessage id={cardsQuestions.cards.header} tagName={'p'} />
        <Button variant={'contained'} className={'ml-5 shrink-0'} onClick={onAddCardRedirect}>
          <FormattedMessage id={cardsQuestions.cards.add} />
        </Button>
      </div>
      <div className={'w-full'}>
        {!hasCards ? (
          <p className={'rounded-sm border border-solid border-gray-300 py-16 text-center text-gray-400'}>
            <FormattedMessage id={cardsQuestions.cards.empty} />
          </p>
        ) : (
          <div className={'grid grid-cols-4 gap-4'}>
            {cards.map((card, index) => (
              <Card
                key={index}
                onDelete={() => onRemoveCardById(card.id)}
                onEdit={() => onEditCardRedirect(card)}
                firstName={card.firstName}
                lastName={card.lastName}
                balance={String(card.balance)}
              />
            ))}
          </div>
        )}
      </div>
      <div className={'mt-8 flex justify-between'}>
        <Button variant={'outlined'} onClick={navigateBack}>
          <FormattedMessage id={'cta.back'} />
        </Button>

        <Button variant={'contained'} onClick={nextStepRedirectHandler}>
          <FormattedMessage id={'cta.continue'} />
        </Button>
      </div>
    </>
  );
};
